export interface IBrand {
  id: string;
  images: IBrandImage[];
  localeMetadata: IBrandLocaleMetadata[];
}

export interface IBrandResponse {
  id: string;
  name: string;
  images: IBrandImage[];
}

export interface IBrandImage {
  id: string;
  url: string;
  sizes: IBrandImageSize[];
}

export interface IBrandImageSize {
  url: string;
  height: number;
}

export interface IBrandLocaleMetadata {
  id?: string;
  key: string;
  value: string;
  locale: string;
}

export interface IBrandAdd {
  imageIds: string[];
  localeMetadata: IBrandLocaleMetadata[];
}
